import Phaser from 'phaser';

/**
 * Legacy launcher — redirects to the village hub.
 * Kept registered so older scene.start('MainMenu') call sites still work.
 */
export class MainMenuScene extends Phaser.Scene {
  constructor() {
    super('MainMenu');
  }

  create(): void {
    this.scene.start('Village');
  }
}
